import React, { useEffect, useState } from 'react'
import * as st from '~/assets/styl/EbookModal.module.styl'
import { Button, Form, Lazyload, Modal } from '~/components'
import Logo from '~/assets/svg/Logo-D-Vert.svg'
import { useLanguage } from '~/hooks'

const WHATSAPP_PHONE = '5548998295198'
const REDIRECT_DELAY = 4000

export default function EbookModal({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) {
  const { t } = useLanguage()
  const [submitted, setSubmitted] = useState(false)
  const [name, setName] = useState('')

  useEffect(() => {
    if (!open) {
      setSubmitted(false)
      setName('')
    }
  }, [open])

  useEffect(() => {
    if (!submitted) return
    const message = t('Ebook.whatsappMessage', {
      name,
      interpolation: { escapeValue: false },
    })
    const timeout = setTimeout(() => {
      window.location.href = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(
        message
      )}`
    }, REDIRECT_DELAY)
    return () => clearTimeout(timeout)
  }, [submitted, name])

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={st.modal}
      lockScroll
      onBeforeClose={() => {
        setSubmitted(false)
        setName('')
      }}
    >
      {(closeProps) => (
        <>
          {!submitted && <button {...closeProps}></button>}
          <div className={st.inner}>
            {submitted ? (
              <div className={st.success}>
                <Lazyload type="img" src={Logo} width="327" height="72" />
                <div className={st.successCard}>
                  <h3>{t('Ebook.successTitle')}</h3>
                  <p>{t('Ebook.successMessage')}</p>
                </div>
              </div>
            ) : (
              <>
                <div className={st.info}>
                  <Lazyload type="img" src={Logo} width="327" height="72" />
                  <h3>{t('Ebook.modalTitle')}</h3>
                  <p>{t('Ebook.modalDescription')}</p>
                </div>
                <Form
                  path="conversions"
                  idPrefix="ebook-modal"
                  className={st.form}
                  hiddenInputs={{
                    token_rdstation: '529cac2f361142d6e1232668a5dbe8f9',
                    identificador: 'dvert-ebook-hotsite',
                    crm_id_empreendimento: '11',
                  }}
                  inputs={[
                    {
                      name: 'nome',
                      label: t('Contact.name'),
                    },
                    {
                      name: 'email',
                      label: t('Contact.email'),
                      type: 'email',
                    },
                    {
                      name: 'telefone',
                      label: t('Contact.phone'),
                      type: 'tel',
                      mask: 'phone',
                    },
                    {
                      name: 'privacy',
                      label: t('Contact.acceptanceStatement'),
                      type: 'checkbox',
                    },
                  ]}
                  onSuccess={(data, setLoading) => {
                    setName((data.nome as string) || '')
                    setSubmitted(true)
                    setLoading(false)
                  }}
                  button={
                    <Button className={st.btn}>{t('Ebook.button')}</Button>
                  }
                />
              </>
            )}
          </div>
        </>
      )}
    </Modal>
  )
}
